import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { CustomReuseStrategy } from './custom-reuse-strategy';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./content/pages/pages.module').then(m => m.PagesModule)
	},
	{
		path: '**',
		redirectTo: '404',
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })
	],
	exports: [RouterModule],
  	providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }]
})
export class AppRoutingModule { }
